var _linearGradient, _clipPath, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 20,
    role: "img",
    "aria-label": "C Sharp",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C Sharp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x2: 0,
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bbb",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 20,
    rx: 3,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0,
    height: 20,
    fill: "#555"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 73,
    height: 20,
    fill: "#239120"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 20,
    fill: "url(#s)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 110
  }, /*#__PURE__*/React.createElement("image", {
    x: 5,
    y: 3,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjZmZmZmZmIiByb2xlPSJpbWciIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGl0bGU+QyBTaGFycDwvdGl0bGU+PHBhdGggZD0iTTEyIDBBMTIgMTIgMCAwMDAgMTJhMTIgMTIgMCAwMDEyIDEyIDEyIDEyIDAgMDAxMi0xMkExMiAxMiAwIDAwMTIgMHpNOS40MjYgNy4xMmE1LjU1IDUuNTUgMCAwMTEuOTg1LjM4djEuMTgxYTQuNSA0LjUgMCAwMC0yLjI1LS41NjYgMy40MzkgMy40MzkgMCAwMC0yLjYyNSAxLjA4NyA0LjA5OSA0LjA5OSAwIDAwLTEuMDEyIDIuOTA2IDMuOSAzLjkgMCAwMC45NDUgMi43NTQgMy4yMTcgMy4yMTcgMCAwMDIuNDgyIDEuMDIzIDQuNjU3IDQuNjU3IDAgMDAyLjQ2NC0uNjM0bC0uMDA0IDEuMDhhNS41NDMgNS41NDMgMCAwMS0yLjYyNS41NTUgNC4yMTEgNC4yMTEgMCAwMS0zLjIyOC0xLjI5NyA0Ljc5MyA0Ljc5MyAwIDAxLTEuMjEyLTMuNDA5IDUuMDIxIDUuMDIxIDAgMDExLjM2NS0zLjY2MyA0LjYzMSA0LjYzMSAwIDAxMy40NzMtMS4zOTIgNS41NSA1LjU1IDAgMDEuMTItLjAwNCA1LjU1IDUuNTUgMCAwMS4xMjIgMHptNS44NjMuMTU1aC44MzZsLS41NTUgMi42NTJoMS42NjFsLjU2Ny0yLjY1MmguODFsLS41NTUgMi42NTIgMS43MzItLjAwNC0uMTUuNjk3SDE3LjkxbC0uNDEyIDEuOThoMS44NTJsLS4xNzYuNjk4aC0xLjgxNmwtLjU4IDIuNjI1aC0uODNsLjU2Ny0yLjYyNWgtMS42NWwtLjU1NSAyLjYyNWgtLjgxbC41NTUtMi42MjVoLTEuNzRsLjEzMS0uNjk4aDEuNzQ4bC40MDEtMS45NzZoLTEuODI2bC4xMzgtLjY5N2gxLjgyNnptLjE0MiAzLjM0NUwxNSAxMi42aDEuNjczbC40MjMtMS45OHoiLz48L3N2Zz4="
  }), /*#__PURE__*/React.createElement("text", {
    "aria-hidden": "true",
    x: 455,
    y: 150,
    fill: "#010101",
    fillOpacity: 0.3,
    transform: "scale(.1)",
    textLength: 450
  }, "C Sharp"), /*#__PURE__*/React.createElement("text", {
    x: 455,
    y: 140,
    transform: "scale(.1)",
    fill: "#fff",
    textLength: 450
  }, "C Sharp"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCs);
export default __webpack_public_path__ + "static/media/cs.cd292b1a5228c2ddf29dd0f016c7cc30.svg";
export { ForwardRef as ReactComponent };